export const codeSetUpThemes = `import { setGlobalTheme } from '@atlaskit/tokens/set-global-theme';

// Load the default ADS themes and follow the user's system color mode.
setGlobalTheme({
  light: 'light',
  dark: 'dark',
  colorMode: 'auto',
});`;

export const codeSetUpThemesShorthand = `import { setGlobalTheme } from '@atlaskit/tokens/set-global-theme';

setGlobalTheme({});`;

export const codeHtmlTheme = `<html data-theme="light:light dark:dark spacing:spacing typography:typography" data-color-mode="light">`;

export const codeUseTokens = `import { token } from '@atlaskit/tokens';
token('color.background.neutral');  // var(--ds-background-neutral)
token('space.200');                 // var(--ds-space-200)
token('font.body');                 // var(--ds-font-body)`;

export const codeBabelPlugin = `// Original code
-import { token } from '@atlaskit/tokens';
-token('space.200');

// Babel plugin output
+var(--ds-space-200, 1rem);`;

export const codeBabelPluginUsage = `// babel.config.json
{
  "plugins": ["@atlaskit/tokens/babel-plugin"]
}`;

export const codeBabelPluginCompiled = `// .compiledscssrc
"transformerBabelPlugins": ["@atlaskit/tokens/babel-plugin"],`;

export const codeFallbackRemovalCodemod = `npx @atlaskit/codemod-cli --preset remove-token-fallbacks /absolute/path/to/code --extensions tsx,ts,js,jsx --forceUpdate --addEslintComments --skipTokens color,font`;

export const codeLintRules = `'@atlaskit/design-system/ensure-design-token-usage': [
  'error',
  {
    domains: ['color', 'spacing'],
    shouldEnforceFallbacks: true
  }
],
'@atlaskit/design-system/no-unsafe-design-token-usage': ['error', { shouldEnforceFallbacks: true }],
'@atlaskit/design-system/no-deprecated-design-token-usage': 'warn'`;
